import { render, staticRenderFns } from "./OpenTable.vue?vue&type=template&id=369645fa&scoped=true&"
import script from "./OpenTable.vue?vue&type=script&lang=js&"
export * from "./OpenTable.vue?vue&type=script&lang=js&"
import style0 from "./OpenTable.vue?vue&type=style&index=0&id=369645fa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "369645fa",
  null
  
)

export default component.exports